module.exports = __webpack_public_path__ + "static/img/home_map.bc63c0a.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/indexPage/home_map.png
// module id = rKCi
// module chunks = 0